import { Directive, ElementRef, Input, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { Subscription } from 'rxjs';
import { GlobalLoadingService } from '../../core/services/global-loading.service';

@Directive({
  selector: '[appGlobalLoadingDisable]',
  standalone: true
})
export class GlobalLoadingDisableDirective implements OnInit, OnDestroy {
  @Input() appGlobalLoadingDisable: boolean | string = true; // Allow boolean or string input
  @Input() preserveDisabled: boolean = false; // Preserve existing disabled state
  
  private originalDisabled: boolean = false;
  private loadingSubscription?: Subscription;
  private isGlobalLoading: boolean = false;

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private globalLoadingService: GlobalLoadingService
  ) {}

  ngOnInit(): void {
    // Convert string input to boolean
    const shouldDisable = this.appGlobalLoadingDisable === true || 
                          this.appGlobalLoadingDisable === 'true' || 
                          this.appGlobalLoadingDisable === '';

    if (!shouldDisable) {
      return;
    }

    // Store original disabled state
    this.originalDisabled = this.elementRef.nativeElement.disabled;

    // Subscribe to global loading state
    this.loadingSubscription = this.globalLoadingService.isLoading$.subscribe(
      (isLoading: boolean) => {
        this.isGlobalLoading = isLoading;
        this.updateDisabledState();
      }
    );
  }

  ngOnDestroy(): void {
    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
    }
  }

  private updateDisabledState(): void {
    const shouldDisable = this.isGlobalLoading || 
      (this.preserveDisabled && this.originalDisabled);

    if (shouldDisable) {
      this.renderer.setAttribute(this.elementRef.nativeElement, 'disabled', 'true');
      this.renderer.addClass(this.elementRef.nativeElement, 'p-disabled');
    } else {
      this.renderer.removeAttribute(this.elementRef.nativeElement, 'disabled');
      this.renderer.removeClass(this.elementRef.nativeElement, 'p-disabled');
    }
  }
}
